module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_50000-e49ccbcaacb3737fdb1e8f63fb8276a3.png";